import { z } from 'zod'
import { expectedPaymentTypeSchema } from './expected-payment-response.schema'

export const paidPaymentResponseSchema = z.object({
  id: z.string().guid(),
  tbankOperationId: z.string(),
  category: expectedPaymentTypeSchema,
  operationDate: z.coerce.date(),
  instrumentUid: z.string().nullable(),
  figi: z.string().nullable(),
  ticker: z.string().nullable(),
  // display name and lowercase T-Bank kind ('share' | 'bond' | 'etf'), resolved from the local
  // instrument cache. optional: absent on older cached responses and on instruments the cache has
  // never seen (a payout on a long-sold position), in which case the client falls back to the ticker.
  instrumentName: z.string().nullable().optional(),
  instrumentType: z.string().nullable().optional(),
  amount: z.number(),
  currency: z.string().nullable(),
  // shares/bonds the payout settled on — lets the income chart tooltip show per-share × quantity.
  // optional: older cached responses may omit it.
  quantity: z.number().optional(),
})

export type PaidPaymentResponseDto = z.infer<typeof paidPaymentResponseSchema>
